<template>
  <div>
    <top-status-bar></top-status-bar>
    <template v-if="payInfo">
      <!-- 支付成功 -->
      <pay-success
        v-if="orderStatus === PaymentStatus.paymentSuccess"
        :pay-method="payMethod"
        :pay-type="payType"
        :order-info="orderInfo"
      ></pay-success>

      <!--  待支付  -->
      <template v-else>
        <div class="header">有看投，让投资大有看头</div>

        <div class="content">
          <!--  待支付   -->
          <template
            v-if="
              orderStatus === PaymentStatus.unPaid ||
              orderStatus === PaymentStatus.paying
            "
          >
            <!-- 支付宝、微信 -->
            <pay-qr-code
              v-if="
                payMethod === PaymentMethods.aliPay ||
                payMethod === PaymentMethods.weXin ||
                payMethod === PaymentMethods.BasepayAli ||
                payMethod === PaymentMethods.basepayWei
              "
              :pay-method="payMethod"
              :order-info="orderInfo"
              :pay-info="payInfo"
              :trade-type="tradeType"
            ></pay-qr-code>
            <!--  财币支付 -->
            <pay-cai-bi
              v-else
              :order-info="orderInfo"
              :order-id="orderId"
              @pay="createPayOrder"
            ></pay-cai-bi>
          </template>
          <!--  支付异常 -->
          <pay-fail v-else :message="errorMessage"></pay-fail>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import TopStatusBar from '@/components/TopTab/TopStatusBar'
import {
  createPayOrder,
  getOrder,
  queryOrderStatus,
  PaymentStatus
} from '@/api/order'
import appInfo from '@/assets/js/appInfo.js'
import PaySuccess from '@/components/CashierDesk/PaySuccess'
import { PaymentMethods } from '@/constant/PaymentMethods'
import PayQrCode from '@/components/CashierDesk/PayQrCode'
import PayCaiBi from '@/components/CashierDesk/PayCaiBi'
import { createRechargeOrder, getRechargeInfo } from '@/api/vcurrency'
import PayFail from '@/components/CashierDesk/PayFail'

export default {
  name: 'CashierDesk',
  components: { PayFail, PayCaiBi, PayQrCode, PaySuccess, TopStatusBar },
  data() {
    const orderId = appInfo.getParam('orderId')
    let payMethod = appInfo.getParam('method')
    let payType = appInfo.getParam('type')
    let tradeType = appInfo.getParam('tradeType')

    if (tradeType) {
      tradeType = parseInt(tradeType)
    }

    if (payMethod) {
      payMethod = parseInt(payMethod)
    }

    if (payType) {
      payType = parseInt(payType)
    }

    return {
      orderId,
      payMethod,
      tradeType,
      payType,
      errorMessage: '',
      // 仅财币充值
      productId: orderId,
      orderInfo: null,
      payInfo: null,
      PaymentStatus,
      PaymentMethods,
      orderStatus: PaymentStatus.unPaid,
      appId: 32
    }
  },
  created() {
    this.initOrder()
  },
  methods: {
    async initOrder() {
      if (this.payType === 2) {
        //  财币充值
        await this.createRechargeOrder()
      } else {
        // 支付

        // 1. 查询订单状态
        await this.getOrder()

        if (this.payMethod !== PaymentMethods.caiBi) {
          // 1.1 支付宝、微信支付
          await this.createPayOrder()
        } else {
          // 1.2 财币支付
          this.payInfo = {
            orderId: this.orderId
          }
        }
      }
    },
    async createPayOrder(code) {
      const { result, detail } = await createPayOrder(
        this.payMethod,
        this.tradeType,
        this.orderId,
        this.appId,
        code
      )
      if (result.code === 0) {
        this.payInfo = detail

        if (this.payMethod === PaymentMethods.caiBi) {
          this.orderStatus = PaymentStatus.paymentSuccess
        }

        if (this.payMethod !== PaymentMethods.caiBi) {
          await this.queryOrderStatus()
        }
      } else {
        this.$toasted.show(result.msg || '支付失败，请重试', {
          position: 'bottom-center',
          duration: 3000
        })
        this.payInfo = {
          orderId: this.orderId
        }
      }
    },
    async getOrder() {
      const orderInfo = await getOrder(this.orderId)

      if (orderInfo) {
        this.orderInfo = orderInfo
        this.orderStatus = orderInfo.orderStatus
      }
    },
    async queryOrderStatus() {
      const orderStatus = await queryOrderStatus(this.orderId)
      this.orderStatus = orderStatus

      this.handlePaymentStatus(orderStatus, this.queryOrderStatus)
    },
    handlePaymentStatus(paymentStatus, callback) {
      switch (paymentStatus) {
        case PaymentStatus.paying:
        case PaymentStatus.unPaid:
          setTimeout(callback, 5000)
          break
        case PaymentStatus.paymentSuccess:
          if (window.opener && !window.opener.closed) {
            window.postMessage(true, '*')
          }
          break
        case PaymentStatus.isClosed:
          this.errorMessage = '订单超时，支付已关闭，请重新下单'
          break
        default:
          this.errorMessage = '订单异常，支付已关闭，请重新下单'
          break
      }
    },
    /**
     * 查询财币充值状态
     * @return {Promise<void>}
     */
    async getRechargeInfo() {
      const { result, detail } = await getRechargeInfo(this.orderId)

      if (result.code === 0) {
        this.orderInfo = {
          actualPrice: detail.totalPaymentAmount
        }

        this.orderStatus = detail.paymentStatus
        this.handlePaymentStatus(detail.paymentStatus, this.getRechargeInfo)
      }
    },
    async createRechargeOrder() {
      const { result, detail } = await createRechargeOrder(
        this.productId,
        this.payMethod,
        this.tradeType,
        this.appId
      )

      if (result.code === 0) {
        this.payInfo = detail
        this.orderId = detail.orderId

        await this.getRechargeInfo()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  margin: 50px 0 0;
  padding-top: 64px;
  font-size: 16px;
  color: #858585;
  text-align: center;
  background: url('~@/assets/images/common/logo.png') no-repeat top;
  background-size: 52px auto;
}

.content {
  margin: 30px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 892px;
  height: 708px;
  background-color: #fafafa;
}
</style>
